import React, { useContext } from 'react';
import CmsDetailsContext from '../../Context/CmsDetails/CmsDetailsContext';
import styles from './ThemeSwitcher.module.scss';

const ThemeSwitcher = () => {
  const { darkMode, setDarkMode } = useContext(CmsDetailsContext);

  const handleThemeChange = () => {
    setDarkMode(!darkMode);
  };

  return (
    <div className={styles.themeSwitcher} onClick={handleThemeChange}>
      <i className="material-icons">
        {darkMode ? 'light_mode' : 'dark_mode'}
      </i>
    </div>
  );
};

export default ThemeSwitcher;